
import Home from '@/views/Home'

const _import = require('./_import_' + process.env.NODE_ENV)

export default {
  path: '/',
  meta: {
    permission: true
  },
  component: Home,
  children: [
    {
      path: 'question',
      name: 'question',
      component: _import('Question'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: 'transition', // 过渡页
      name: 'transition',
      component: _import('Transition'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
      path: 'target', // 目标页
      name: 'target',
      component: _import('Target'),
      meta: {
        permission: true,
        allowBack: false,
        noCache: true
      }
    },
    {
        path: 'importVideo', // 单视频
        name: 'importVideo',
        component: _import('ImportVideo'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'composition', // 作文
        name: 'composition',
        component: _import('Composition'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'compositioncorrected', // 作文批改
        name: 'compositioncorrected',
        component: _import('CompositionCorrected'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'pointVideo', // 
        name: 'PointVideo',
        component: _import('PointVideo'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'footprint', // 流程15-学习足迹
        name: 'footprint',
        component: _import('footPrint'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
      {
        path: 'commonvideo', // 流程15-拓展视频
        name: 'commonvideo',
        component: _import('commonvideo'),
        meta: {
          permission: true,
          allowBack: false,
          noCache: true
        }
      },
  ]
}



// WEBPACK FOOTER //
// ./src/router/other.js